

const state = {
  importResultWorker: null,
  resultImport: null,

  /**
   * Biến trạng thái quyết định tăng lên 1 bước
   */
  stateAddStep: false,
};

const getters = {
  resultImportWorker(state) {
    return state.importResultWorker;
  },

  resultImport(state) {
    return state.resultImport;
  }
};

const actions = {
};

const mutations = {
  setImportResultWorker(state, data) {
    state.importResultWorker = data;
  },

  setImportResult(state, data) {
    state.resultImport = data;
  },
  
  /**
   * Trigger tăng lên 1 bước
   * @param {*} state 
   * @author: BMThang(17/05/2023)
   */
  triggerAddStep(state) {
    state.stateAddStep = !state.stateAddStep;
  },
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};